var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46447 18.5355C2.92893 20 5.28595 20 10 20C14.714 20 17.0711 20 18.5355 18.5355C20 17.0711 20 14.714 20 10C20 5.28595 20 2.92893 18.5355 1.46447C17.0711 0 14.714 0 10 0C5.28595 0 2.92893 0 1.46447 1.46447C0 2.92893 0 5.28595 0 10C0 14.714 0 17.0711 1.46447 18.5355ZM7.5 6.75C5.70507 6.75 4.25 8.20507 4.25 10C4.25 11.7949 5.70507 13.25 7.5 13.25C9.29493 13.25 10.75 11.7949 10.75 10C10.75 9.58579 11.0858 9.25 11.5 9.25C11.9142 9.25 12.25 9.58579 12.25 10C12.25 12.6234 10.1234 14.75 7.5 14.75C4.87665 14.75 2.75 12.6234 2.75 10C2.75 7.37665 4.87665 5.25 7.5 5.25C7.91421 5.25 8.25 5.58579 8.25 6C8.25 6.41421 7.91421 6.75 7.5 6.75ZM15.75 10C15.75 11.7949 14.2949 13.25 12.5 13.25C12.0858 13.25 11.75 13.5858 11.75 14C11.75 14.4142 12.0858 14.75 12.5 14.75C15.1234 14.75 17.25 12.6234 17.25 10C17.25 7.37665 15.1234 5.25 12.5 5.25C9.87665 5.25 7.75 7.37665 7.75 10C7.75 10.4142 8.08579 10.75 8.5 10.75C8.91421 10.75 9.25 10.4142 9.25 10C9.25 8.20507 10.7051 6.75 12.5 6.75C14.2949 6.75 15.75 8.20507 15.75 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSources);
export default __webpack_public_path__ + "static/media/Sources.18553fb078ce53aceac29a45ed1f002e.svg";
export { ForwardRef as ReactComponent };